import { useEffect } from "react";
import { Outlet, ScrollRestoration, useMatches } from "react-router";

import { GoogleAnalytics } from "@rai/ui/analytics/google-analytics";
import { siteConfig } from "@rai/core/lib/site";
import { useImpersonation } from "@/lib/use-impersonation";

type Handle = { title?: string };

/**
 * The deepest matched route with a `handle.title` names the tab, as Next's
 * metadata did. A tab acting as a business says so first, so it isn't
 * mistaken for another.
 */
function DocumentTitle() {
  const matches = useMatches();
  const acting = useImpersonation();
  const title = matches.map(match => (match.handle as Handle | undefined)?.title).filter(Boolean).at(-1);
  const prefix = acting && !acting.ended ? `Acting as ${acting.workspaceName} · ` : "";
  useEffect(() => {
    document.title = prefix + (title ? `${title} · ${siteConfig.name}` : siteConfig.name);
  }, [title, prefix]);
  return null;
}

export function Root() {
  return (
    <>
      <DocumentTitle />
      <Outlet />
      <ScrollRestoration />
      <GoogleAnalytics measurementId={process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ?? "G-KCGVMBQKYD"} />
    </>
  );
}
